
$(document).ready(function(){
  let accordion = [
  {
    'title':'Which WisGate gateway should I choose for my use case?',
    'description':`
    <ol style="list-style-type: decimal; padding-left: 20px;">
        <li><b>Outdoor industrial & city-scale:</b> WisGate Edge Pro / Edge Prime / Edge Ultra Full-Duplex for rugged, long-range LoRaWAN coverage with multi-backhaul (Ethernet/WiFi/LTE).</li>
        <li><b>Outdoor small-scale & smart agriculture:</b> WisGate Soho Pro RAK7267 has integrated antennas and Cat-1LTE connectivity ideal for small city projects.</li>
        <li><b>Indoor enterprise & buildings:</b> WisGate Edge Lite 2 or WisGate Soho Lite for compact 8-channel indoor LoRaWAN gateways.</li>
        <li><b>Hybrid / multi-radio & I/O at the edge:</b> WisGate Connect family (Industrial, Outdoor, Smart Building) built on Raspberry Pi CM4 and RAK7391 carrier board.</li>
        <li><b>Prototyping & rollouts:</b> WisGate Developer series (D4/CM4), RAK5146 PiHAT Kit, or Developer Base (USB-C concentrator).</li>
    </ol>
    <p><b>Tip:</b> If you need 16 channels or IP67, start with Edge Pro; for low latency and heavy two-way traffic, choose Edge Ultra Full-Duplex.</p>`
  },
  {
    'title':'What’s the difference between Edge, Connect, and Soho gateways?',
    'description':`
    <ol style="list-style-type: decimal; padding-left: 20px;">
        <li><b>WisGate Edge (Pro/Prime/Lite/Ultra):</b> ready-to-deploy commercial LoRaWAN gateways with WisGateOS 2, fleet management in WisDM, and options for 8 or 16 channels, IP65/IP67, and LTE.</li>
        <li><b>WisGate Connect:</b> CM4-based edge platforms (RAK7391) for custom radios (sub-GHz + 2.4 GHz LoRaWAN, mioty®), industrial I/O (ModBUS, 4–20 mA, analog/digital), and PoE/DC flexibility.</li>
        <li><b>WisGate Soho (Lite/Pro):</b> cost-effective indoor/outdoor LoRa gateways for small to mid-sized deployments, with Cat-1 LTE options with WisGateOS 2, fleet management in WisDM.</li>
    </ol>`
  },
  {
    'title':'Do WisGate gateways work with ChirpStack, The Things Stack (TTN/TTS), AWS IoT Core for LoRaWAN, and Actility?',
    'description':`<p>
    <b>Yes.</b> Models support Basics Station and Packet Forwarder and are compatible with ChirpStack v3/v4, TTS/TTN, AWS IoT Core for LoRaWAN, Actility (model-dependent), and more.
    </p>
    <p>
    WisGateOS 2 includes MQTT v3.1 over TLS, LoRa® frame filtering (node allow-list), and buffering to prevent data loss during network outages.
    </p>
    `
  },
  {
    'title':'How many channels do I need? 8-channel vs 16-channel LoRaWAN gateway?',
    'description':`<p>
    <b>8-channel</b> is ideal for small to mid-scale sites, pilots, and buildings.
    For real-time two-way traffic, consider Edge Ultra Full-Duplex.
    </p>
    <p>
    <b>16-channel</b> is better for large-scale, high-density, or high-traffic sites, as it can handle more simultaneous transmissions and reduce collisions.
    </p>
    <p>For real-time two-way traffic, consider Edge Ultra Full-Duplex.</p>
    `
  },
  {
    'title':'What LoRaWAN frequency plans and regions are supported?',
    'description':`<p>
    Gateways and antennas are offered for <b>EU868, US915, AU915, AS923, KR920, IN865, RU864</b> (and others where stated).
    </p>
    <p>Always order the SKU that matches your local band range and regulatory requirements. Antenna bundles also vary by band range.</p>
    `
  },
  {
    'title':'Does WisGate support dual-band LoRaWAN (sub-GHz + 2.4 GHz) and mioty®?',
    'description':`<p>
    WisGate Connect can be configured for <b>dual-band (sub-GHz + 2.4 GHz LoRaWAN)</b> and can add mioty® via the Miromico EdgeCard.
    </p>
    <p>WisGate Connect for mioty® ships as a dual-protocol gateway (mioty + LoRaWAN). <b>Current mioty band:</b> 868 MHz.</p>
    `
  },
  {
    'title':'PoE vs DC power: what should I use, and can I power from solar?',
    'description':`<p>
    Many gateways support <b>PoE (802.3af/at) and/or DC</b> (model-dependent).
    </p>
    <p><b>Do not</b> connect solar chargers directly to DC ports on models that prohibit it (e.g., Edge Pro, Edge Ultra, Edge Prime DC/Battery Plus).</p>
    <p>For off-grid and solar, use <b>RAK Battery Plus</b> (IP65 LiFePO₄ + charger/heater + telemetry) or <b>Solar Battery Lite</b> for short-term backup.</p>
    `
  },
  {
    'title':'Which antenna gain should I choose?',
    'description':`
    <p><b>3 dBi:</b> better near-field fill in urban/suburban sites; fewer blind spots close to the tower.</p>
    <p><b>5–5.8 dBi:</b> balanced footprint for towns/edge-of-city.</p>
    <p><b>8 dBi:</b> longer-range coverage in rural/open terrain.</p>
    <p><b>12 dBi directional:</b> point-to-sector when devices are in one direction; maximizes reach and SNR.</p>
    <p>Always match frequency band and connector type (e.g., N-Type, RP-SMA) to your gateway and region.</p>
    `
  },
      {
    'title':'Can I use LTE backhaul and which SIM should I get?',
    'description':`
    <p>WisGate Soho models offer <b>LTE Cat-1</b> (or optional LTE modules), majority of other models support <b>Cat-4</b>.</p>
    <p>Use a <b>data-only M2M/IoT SIM</b> with coverage in your deployment region.</p>
    <p>External LTE antennas can improve <b>RSRP/RSRQ</b> in weak-signal areas (see LTE Antenna accessory).</p>
    `
  },
  {
    'title':'Do I need GPS/GNSS?',
    'description':`
    <p><b>GPS</b> is useful for time sync, location metadata, and fine timestamping (on supported models).</p>
    <p>Outdoor gateways often include internal GPS antennas; for optimal performance, ensure clear sky view or use the <b>GPS Antenna accessory</b>.</p>
    `
  },
  {
    'title':'How do I plan placement for best LoRaWAN coverage?',
    'description':`
    <p><b>Mount as high as possible</b> with clear line of sight; avoid nearby metal/reflective surfaces.</p>
    <p><b>Use low-loss coax, keep pigtails short, and weather-seal</b> outdoor connectors.</p>
    <p>Pick antenna gain based on environment (see Q9) and match region band.</p>
    <p>For very large or complex sites, consider <b>Gateway Mesh</b> or additional gateways to fill weak spots.</p>
    `
  },
  {
    'title':'Are firmware, security, and updates remote-managed?',
    'description':`
    <p><b>Yes.</b> WisDM (the <a href="https://www.rakwireless.com/en-us/products/wisdm?utm_source=rak_store&utm_medium=organic&utm_campaign=wisgate_collection_page&utm_term=rak_cloud_management_platform&utm_content=product_page_link">RAK cloud management platform</a>) lets you manage gateways at scale — with OTA firmware updates, configuration templates, fleet-wide policies, alerting, and role-based access control. All communication is secured with TLS encryption.</p>
    `
  },
  {
    'title':'What’s included with gateways? Are antennas and power supplies in the box?',
    'description':`
    <p><b>Contents vary by model;</b> check the product page for exact inclusions.</p>
    <p><b>High-gain LoRa antennas, PoE injectors/splitters, Battery Plus, and global PSUs</b> are available under Accessories.</p>
    `
  },
  {
    'title':'Are there any power cautions I should know?',
    'description':`
    <p>Some models are <b>DC-only</b> and must not be connected directly to generic solar chargers; use <b>RAK Battery Plus</b> or the specified <b>PoE/PSU</b>.</p>
    <p>Verify <b>PoE class/budget (802.3af/at)</b> when using injectors/switches; check datasheets for consumption.</p>
    `
  }
  ]

  let accordion_html = ''

  accordion.map(a=>{
    accordion_html+=`
      <div class="accordion__container">
        <div class="accordion">
          <h3>${a.title}</h3>
          <img src="https://cdn.shopify.com/s/files/1/0177/8784/6756/files/accordion.svg?v=1723128392" class="arrow"/>
        </div>
        <div class="panel">
          ${a.description}
        </div>
      </div>
    `
  })

  $('.wisgate .accordions').html(accordion_html)

  
  $('.wisgate .accordion').on('click',function(){
    $(this).next().toggle()
    if($(this).next().is(":visible"))
      $(this).find('.arrow').css('transform' , 'rotate(0deg)');
    else
      $(this).find('.arrow').css('transform' , 'rotate(180deg)');
  })

  let featured_projects = [
    {
      'img':'https://cdn.shopify.com/s/files/1/0177/8784/6756/files/2mobile.png?v=1730270454',
      'title':'MOBILE',
      'description':`
      <p>Earn $MOBILE tokens for helping build the Helium Network, a new network owned and operated by people</p>
      <p>MNTD. is the first third-party MOBILE Hotspot vendor on the Helium Network.</p>`
    },
    {
      'img':'https://cdn.shopify.com/s/files/1/0177/8784/6756/files/iot.png?v=1730270454',
      'title':'IOT',
      'description':`
      <p>Earn $IOT tokens for building the Helium IOT Network</p>
      <p>RAKwireless is the same company that created the original hotspots for Helium and has deployed the largest number of Hotspots to date.</p>
      `
    },
    {
      'img':'https://cdn.shopify.com/s/files/1/0177/8784/6756/files/energy.png?v=1730270453',
      'title':'Energy',
      'description':`
      <p>Earn  beta rewards by building the world's largest virtual power plant</p>
      <p>Unlock the full potential of your renewable energy resources with Sourceful.</p>
      `
    }

  ]
  let featured_html = ''
  featured_projects.map(f=>{
    featured_html += `
    <a href="#" class="card">
      <div><img src="${f.img}"/></div>
      <div class="card__title">${f.title}</div>
      <div class="card__description">
        ${f.description}
      </div>
    </a>
    `
  })

  $('.wisgate .cards').html(featured_html)

  
  const swiper_collection = new Swiper('.collection .swiper',{
      enabled:true,
      slidesPerView:2,
      spaceBetween:0,
      freeMode: true,
      slidesOffsetAfter:180,
      breakpoints: {
        769: {
          slidesPerView:5,
          enabled:false
        }
      }
      
  });
})